var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFundRequest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FF0000;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M418.5,0H93.5v64.6h114.6c42.1,0,78,27,91.3,64.6H93.5v64.6h205.9c-13.3,37.6-49.2,64.6-91.3,64.6H93.5v64.6 L282.7,512l45.6-45.7L184.8,322.8h23.3c77.9,0,143.2-55.5,158.2-129.1h52.2v-64.6h-52.2c-4.9-23.8-15-45.8-29.1-64.6h81.3V0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFundRequest);
export default __webpack_public_path__ + "static/media/FundRequest.0356efe8fbf22017dd1f0829bfd44255.svg";
export { ForwardRef as ReactComponent };